export { default } from './BrandedBox'
